import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { toast.error(formatApiError(err)); }
    setLoading(false);
  };

  if (sent) {
    return (
      <div className="min-h-screen grid place-items-center p-6">
        <div className="w-full max-w-md surface-card p-8 text-center" data-testid="forgot-sent">
          <div className="w-12 h-12 rounded-full bg-forest/10 grid place-items-center mx-auto mb-4">
            <Mail className="w-6 h-6 text-forest" />
          </div>
          <h2 className="text-2xl font-heading font-semibold">Proveri svoj email</h2>
          <p className="text-sm text-ink-muted mt-3">
            Ako nalog sa tim email-om postoji, poslali smo ti link za promenu lozinke. Link ističe za 30 minuta.
          </p>
          <Link to="/login" className="btn-primary mt-6 inline-flex" data-testid="link-back-login">
            Nazad na prijavu
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen grid place-items-center p-6">
      <form onSubmit={submit} className="w-full max-w-md surface-card p-8" data-testid="forgot-form">
        <div className="overline mb-2">Reset lozinke</div>
        <h2 className="text-3xl font-heading font-semibold tracking-tight">Zaboravili ste lozinku?</h2>
        <p className="text-sm text-ink-muted mt-2">Unesite email i poslaćemo vam link za promenu lozinke.</p>

        <div className="mt-6 space-y-4">
          <div>
            <label className="text-sm font-medium">Email</label>
            <input
              data-testid="forgot-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full mt-1 px-3 py-2.5 bg-white border border-line rounded-md focus:outline-none focus:ring-2 focus:ring-forest"
              required
            />
          </div>
          <button data-testid="forgot-submit" disabled={loading} className="btn-primary w-full justify-center">
            {loading ? "Šaljem..." : "Pošalji link"}
          </button>
        </div>

        <div className="text-sm text-ink-muted mt-6">
          <Link to="/login" data-testid="link-login" className="text-forest font-medium hover:underline">← Nazad na prijavu</Link>
        </div>
      </form>
    </div>
  );
}
